import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import TrustBand from "../components/TrustBand";

// Lazy — the chat widget isn't on the critical path (only loads when the
// user opens it, but even the closed state's button + listeners aren't
// worth the ~2KB on first paint, which would push us past the 80KB
// Teams budget).
const OpenWatchChatWidget = lazy(
  () => import("../components/OpenWatchChatWidget"),
);

function AppLayout() {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <Topbar />
        <div className="px-6 py-6 max-w-[1600px] w-full mx-auto flex-1 flex flex-col">
          <div className="flex-1">
            <Outlet />
          </div>
          {/* Trust band — every page gets the compliance posture in the
              footer. Lawyers look for SOC 2 / ISO / data residency cues
              without us having to redesign each page. */}
          <TrustBand />
        </div>
      </main>
      {/* Floating OpenWatch assistant — same backend as the Teams bot,
          follows the user across every page. */}
      <Suspense fallback={null}>
        <OpenWatchChatWidget />
      </Suspense>
    </div>
  );
}

export default AppLayout;
